// User Module vuex
//import { apolloClient } from '@/apollo'

// Graph
//import { GetUser, GetWorkers, GetIssues, GetPremium } from '@/graphql/user'

import axios from 'axios'

// Hooks
import dataValidates from '@/hooks/dataValidates'
import dataFiles from '@/hooks/dataFiles'
import dataClone from '@/hooks/dataClone'
import dataSet from '@/hooks/dataSet'
import dataSetItems from '@/hooks/dataSetItems'
import guideData from '@/data/guideData'
import guidesFilterData from '@/data/guidesFilterData'

// State Module
const state = {
  item: null,
  itemTabs: [
    {id: 1, name: 'Общее', active: true},
    {id: 2, name: 'Галерея', active: false},
    {id: 3, name: 'Отзывы', active: false},
    {id: 4, name: 'Флипчарт', active: false},
    {id: 5, name: 'Флипчарт 2', active: false}
  ],
  items: [],
  data: guideData,
  filters: guidesFilterData,
  remove: null,
  loader: false,
  banner: [],
  filterView: false,
  removeFile: null,
  total: null,
  page: 1
}

// Getters Module
const getters = {

  // Get Active Tab
  getActiveTab: state => {
    return state.itemTabs.filter(item => item.active)[0]?.id
  },

  // Get Banner Valid
  getBannerValid: state => value => {
    return state.banner.filter(item => item.id === value.id)[0] || false
  }

}

// Actions Module
const actions = {

  // Set Items Action
  async setItems ({ dispatch, state, commit }) {
    commit('setLoader', true)

    // Get Categoryes
    await axios.get('/category/get/list').then(({ data }) => {
      if (data && (data.entities)) {
        commit('setData', dataSetItems(state.data, {key: 'category', items: data.entities.map(item => {
          return {
            value: item._id,
            name: item.title
          }
        })}))
        commit('setTotal', Math.ceil(data.total_count / 12));
        if (state.total > 0 && (state.total < state.page)) {
          commit('setPage', (state.page - 1) > 1 ? state.page - 1 : 1)
          dispatch('setItems')
        }
      }
    }).catch(error => {
      console.log(error)
    }).finally(() => {
      commit('setLoader', false)
    })

    const page = state.page > 1 ? '?page=' + state.page : ''

    // Get Guides
    axios.get('/guide/admin-get/list' + page).then(({ data }) => {
      if (data && (data.entities)) {
        commit('setItems', data.entities.map(item => {
          return {
            id: item._id,
            title: item.title,
            url: item.url,
            price: Number(item.price),
            category: item.category ? item.category._id : null,
            newprice: Number(item.newprice),
            points: Number(item.points),
            description: item.description,
            period: Number(item.period),
            pages: Number(item.pages),
            budget: Number(item.budget),
            guide_of_the_day: item.guide_of_the_day || false,
            cover: item.cover || null,
            pdf: item.pdf ? { name: item.pdf.oldfilename, value: item.pdf.url, id: item.pdf._id } : null,
            imageContent: item.imageContent ? { name: item.imageContent.oldfilename, value: item.imageContent.url, id: item.imageContent._id } : null,
            imageMaproutes: item.imageMaproutes ? { name: item.imageMaproutes.oldfilename, value: item.imageMaproutes.url, id: item.imageMaproutes._id } : null,
            special: item.special || false,
            gallery: item.gallery && (Array.isArray(item.gallery)) ? item.gallery.map(file => {
              return {
                id: file._id,
                name: file.filename || null,
                data: file.url || null
              }
            }) : [],
            reviews: item.reviews && (Array.isArray(item.reviews)) ? item.reviews.map(file => {
              return {
                id: file._id,
                name: file.filename || null,
                data: file.url || null
              }
            }) : [],
            flipchart: item.flipchart && (Array.isArray(item.flipchart)) ? item.flipchart.map(file => {
              return {
                id: file._id,
                name: file.filename || null,
                data: file.url || null
              }
            }) : [],
            flipchart2: item.flipchart2 && (Array.isArray(item.flipchart2)) ? item.flipchart2.map(file => {
              return {
                id: file._id,
                name: file.filename || null,
                data: file.url || null
              }
            }) : [],
            day: false
          }
        }))
      }
    }).catch(error => {
      console.log(error)
    }).finally(() => {
      commit('setLoader', false)
    })

  },

  // Set Item Action
  setItem ({ state, commit }, value) {
    commit('setItemTabs', state.itemTabs.map((item, i) => {
      item.active = i === 0 ? true : false
      return item
    }))
    commit('setData', dataSet(state.data, value))
    commit('setItem', value)
    commit('setRemoveFile', null)
    commit('setRemove', null)
  },

  // Set New Item Action
  setNewGuide ({ state, commit }) {
    commit('setData', dataSet(state.data, null))
    commit('setItem', dataClone(state.data, {id: null}, true))
    commit('setRemoveFile', null)
    commit('setRemove', null)
  },

  // Save Function
  saveFunction ({ state, commit, dispatch}) {
    commit('setLoader', true)
    const params = {
      title: state.data.title.value || null,
      url: state.data.url.value || null,
      price: state.data.price.value || null,
      category: state.data.category.value ? state.data.category.value.value || null : null,
      newprice: state.data.newprice.value || null,
      points: state.data.points.value || null,
      description: state.data.description.value || null,
      period: String(state.data.period.value) || null,
      pages: state.data.pages.value || null,
      budget: String(state.data.budget.value) || null,
      cover: state.data.cover.value || null,
      pdf: state.data.pdf.value ? {id: state.data.pdf.value.id, name: state.data.pdf.value.name, data: state.data.pdf.value.value} : null,
      imageContent: state.data.imageContent.value ? {id: state.data.imageContent.value.id, name: state.data.imageContent.value.name, data: state.data.imageContent.value.value} : null,
      imageMaproutes: state.data.imageMaproutes.value ? {id: state.data.imageMaproutes.value.id, name: state.data.imageMaproutes.value.name, data: state.data.imageMaproutes.value.value} : null,
      special: state.data.special.value || false,
      gallery: state.data.gallery.value ? state.data.gallery.value.map(file => {
        return {
          id: file.id || null,
          name: file.name || null,
          data: file.data || null
        }
      }) : [],
      reviews: state.data.reviews.value ? state.data.reviews.value.map(file => {
        return {
          id: file.id || null,
          name: file.name || null,
          data: file.data || null
        }
      }) : [],
      flipchart: state.data.flipchart.value ? state.data.flipchart.value.map(file => {
        return {
          id: file.id || null,
          name: file.name || null,
          data: file.data || null
        }
      }) : [],
      flipchart2: state.data.flipchart2.value ? state.data.flipchart2.value.map(file => {
        return {
          id: file.id || null,
          name: file.name || null,
          data: file.data || null
        }
      }) : []
    }
    if (state.item.id) {
      params.id = state.item.id
    }
    axios.post(params.id ? '/guide/update' : '/guide/create', params).then().catch(error => {
      console.log(error)
    }).finally(() => {
      commit('setData', dataSet(state.data, null))
      commit('setItem', null)
      commit('setRemoveFile', null)
      dispatch('setItems')
    })
  },

  // Set Item Tab Action
  setItemTab ({ state, commit }, value) {
    commit('setItemTabs', state.itemTabs.map(item => {
      item.active = value.id === item.id ? true : false
      return item
    }))
  },

  // Set Data Action
  setData ({ state, commit }, value) {
    commit('setData', dataValidates(state.data, value))
  },

  setFile ({ state, commit }, value) {
    commit('setData', dataFiles(state.data, value))
  },

  // Set Remove Action
  setRemove ({ commit }, value) {
    commit('setData', dataSet(state.data, null))
    commit('setItem', null)
    commit('setRemoveFile', null)
    commit('setRemove', value)
  },

  // Remove Function Action
  removeFunction ({ dispatch, state, commit }) {
    if (state.remove) {
      commit('setLoader', true)
      axios.post('/guide/delete', {id: state.remove.id}).then().catch(error => {
        console.log(error)
      }).finally(() => {
        commit('setRemove', null)
        dispatch('setItems')
      })
    }
  },

  // Set Day Action
  setDay ({ state, commit }, value) {
    if (!value.guide_of_the_day) {
      commit('setLoader', true)
      axios.post('/guide/set_guide_of_the_day', {id: value.id}).then().catch(error => {
        console.log(error)
      }).finally(() => {
        commit('setItems', state.items.map(item => {
          if (item.id === value.id) {
            item.guide_of_the_day = !value.guide_of_the_day
          } else {
            item.guide_of_the_day = false
          }
          return item
        }))
        commit('setLoader', false)
      })
    }
  },

  // Set Remove File Action
  setRemoveFile ({ commit }, value) {
    commit('setRemoveFile', value)
  },

  // Remove file Function Action
  removeFileFunction ({ state, commit }) {
    commit('setData', dataFiles(state.data, state.removeFile))
    commit('setRemoveFile', null)
  },

  // Set Page
  setPage ({ dispatch, commit }, value) {
    // set the value in store page variable
    commit('setPage', value.page)
    // check if dispatch function exists then call it
    if (value.dispatchFn) {
      dispatch(value.dispatchFn)
    }
  },

  // Set Banners Action
  async setBanners ({ dispatch, commit }) {
    await dispatch('setItems')
    commit('setLoader', true)
    axios.get('/mainpage/get').then(({ data }) => {
      commit('setBanner', data.guides_offer)
    }).catch(error => {
      console.log(error)
    }).finally(() => {
      commit('setLoader', false)
    })
  },

  // Set Banner Action
  setBanner ({ commit }, value) {
    commit('setBanner', value)
  },

  // Remove Banner Action
  removeBanner ({ commit }, value) {
    commit('setBanner', state.banner.filter((item, i) => {
      if (value !== i) {
        return item
      }
    }))
  },

  // Save Banner Action
  saveBanner ({ state, commit }) {
    if (state.banner.length > 0) {
      commit('setLoader', true)
      axios.post('/mainpage/set_banner_guides', {guides: state.banner.map((item) => {
        return item.id || item._id || null
      })}).then(({ data }) => {
        console.log(data)
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        commit('setLoader', false)
      })
    }
  },

  // Set Filter View Action
  setFilterView ({ state, commit }) {
    commit('setFilterView', !state.filterView)
  }

}

// Mutations Module
const mutations = {

  // Set Items Mutation
  setItems (state, value) {
    state.items = value
  },

  // Set Guide Mutation
  setItem (state, value) {
    state.item = value
  },

  // Set Item Tab Mutation
  setItemTabs (state, value) {
    state.itemTabs = value
  },

  // Set Data Mutation
  setData (state, value) {
    state.data = value
  },

  // Set Item Mutation
  setRemove (state, value) {
    state.remove = value
  },

  // Set Loader File Mutation
  setLoader (state, value) {
    state.loader = value
  },

  // Set Banner Mutation
  setRemoveFile (state, value) {
    state.removeFile = value
  },

  // Set Remove File Mutation
  setFilterView (state, value) {
    state.filterView = value
  },

  // Set Total Mutation
  setTotal (state, value) {
    state.total = value
  },

  // Set Page Mutation
  setPage (state, value) {
    state.page = value
  },

  // Set Banner Mutation
  setBanner (state, value) {
    state.banner = value
  }

}

// Export Module
export default {
  root: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
